// MFE entry point
//    - @author Naroa Gonzalez Sanchez <naroa@hp.com>
//    - @date February 27th 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.

import Template from './root.component';

export default Template;
